const MissionSP = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="180.002"
      height="170.24"
      viewBox="0 0 180.002 170.24"
    >
      <g transform="translate(-575.893 -182.548)">
        <path
          d="M580.773,204.449v-19.5h7.508v19.306c0,5.558,2.779,8.434,7.362,8.434S603,209.909,603,204.5v-19.55h7.508v19.257c0,10.335-5.8,15.405-14.967,15.405S580.773,214.492,580.773,204.449Z"
          transform="translate(-1.906 -0.937)"
          fill="#00a26a"
        />
        <path
          d="M644.453,197.755h7.41v3.705c1.706-2.194,3.9-4.193,7.654-4.193,5.607,0,8.873,3.705,8.873,9.7v16.917H660.98V209.31c0-3.51-1.657-5.314-4.485-5.314s-4.631,1.8-4.631,5.314v14.577h-7.41Z"
          transform="translate(-26.78 -5.75)"
          fill="#00a26a"
        />
        <path
          d="M698.452,182.548h7.41v35.589h-7.41Z"
          transform="translate(-47.873)"
        />
        <path
          d="M723.57,210.968v-.1c0-7.508,6.046-13.6,14.187-13.6,8.093,0,14.09,6,14.09,13.5v.1c0,7.508-6.046,13.6-14.187,13.6C729.567,224.472,723.57,218.475,723.57,210.968Zm20.964,0v-.1a6.943,6.943,0,0,0-6.874-7.215c-4.241,0-6.776,3.266-6.776,7.118v.1a6.943,6.943,0,0,0,6.874,7.215C742,218.085,744.534,214.819,744.534,210.968Z"
          transform="translate(-57.684 -5.75)"
        />
        <path
          d="M778.689,210.968v-.1a13.417,13.417,0,0,1,13.7-13.6c4.924,0,8,1.658,10.433,4.388l-4.534,4.876a7.634,7.634,0,0,0-5.948-2.876c-3.705,0-6.338,3.266-6.338,7.118v.1c0,4,2.584,7.215,6.63,7.215,2.486,0,4.193-1.073,6-2.779l4.339,4.388a13.16,13.16,0,0,1-10.677,4.778A13.343,13.343,0,0,1,778.689,210.968Z"
          transform="translate(-79.214 -5.75)"
        />
        <path
          d="M829.751,182.548h7.41v18.964l8.678-9.507h8.873l-9.945,10.287,10.287,15.844H846.57l-6.825-10.677-2.584,2.73v7.946h-7.41Z"
          transform="translate(-99.159)"
        />
        <path
          d="M589.008,315.619l-13.115-20.671h8.775l8.142,13.7,8.288-13.7h8.531l-13.114,20.525v13.6h-7.508Z"
          transform="translate(0 -43.904)"
        />
        <path
          d="M631.172,320.968v-.1c0-7.508,6.046-13.6,14.187-13.6,8.093,0,14.09,6,14.09,13.5v.1c0,7.508-6.046,13.6-14.187,13.6C637.169,334.472,631.172,328.475,631.172,320.968Zm20.964,0v-.1a6.943,6.943,0,0,0-6.874-7.215c-4.241,0-6.776,3.266-6.776,7.118v.1a6.943,6.943,0,0,0,6.874,7.215C649.6,328.085,652.136,324.819,652.136,320.968Z"
          transform="translate(-21.592 -48.717)"
        />
        <path
          d="M689.652,324.985V308.068h7.41v14.577c0,3.51,1.657,5.314,4.485,5.314s4.631-1.8,4.631-5.314V308.068h7.411V334.2h-7.411v-3.705c-1.706,2.194-3.9,4.193-7.654,4.193C692.918,334.687,689.652,330.982,689.652,324.985Z"
          transform="translate(-44.435 -49.029)"
        />
        <path
          d="M745.01,307.748h7.411v5.265c1.511-3.608,3.949-5.948,8.337-5.753v7.751h-.39c-4.924,0-7.946,2.974-7.946,9.215v9.653H745.01Z"
          transform="translate(-66.058 -48.709)"
        />
        <path
          d="M576.853,404.948h8.288l8.922,24.035,8.922-24.035h8.093l-13.8,34.37h-6.63Z"
          transform="translate(-0.375 -86.871)"
        />
        <path
          d="M636.613,436.5v-.1c0-5.7,4.339-8.337,10.531-8.337a18.573,18.573,0,0,1,6.386,1.073V428.7c0-3.071-1.9-4.778-5.607-4.778a19.223,19.223,0,0,0-7.215,1.414l-1.852-5.656a23.055,23.055,0,0,1,10.141-2.1c4.046,0,6.971,1.073,8.824,2.925,1.95,1.95,2.828,4.827,2.828,8.337v15.162h-7.167v-2.828a10.047,10.047,0,0,1-7.9,3.315C640.659,444.5,636.613,441.672,636.613,436.5Zm17.015-1.706v-1.316a11.493,11.493,0,0,0-4.729-.975c-3.169,0-5.119,1.268-5.119,3.608v.1c0,2,1.658,3.169,4.046,3.169C651.287,439.38,653.628,437.479,653.628,434.8Z"
          transform="translate(-23.718 -91.808)"
        />
        <path
          d="M690.692,402.548H698.1v35.589h-7.411Z"
          transform="translate(-44.841 -85.934)"
        />
        <path
          d="M719.172,434.985V418.068h7.41v14.577c0,3.51,1.657,5.314,4.485,5.314s4.631-1.8,4.631-5.314V418.068h7.411V444.2H735.7v-3.705c-1.706,2.194-3.9,4.193-7.654,4.193C722.438,444.687,719.172,440.982,719.172,434.985Z"
          transform="translate(-55.966 -91.996)"
        />
        <path
          d="M769.25,430.968v-.1c0-7.459,5.315-13.6,12.92-13.6,8.727,0,12.725,6.777,12.725,14.187,0,.585-.049,1.268-.1,1.95H776.612A6.06,6.06,0,0,0,783,438.524a8.562,8.562,0,0,0,6.338-2.681l4.241,3.754a13.068,13.068,0,0,1-10.677,4.875C775.052,444.472,769.25,438.963,769.25,430.968Zm18.429-2.194c-.439-3.315-2.389-5.558-5.509-5.558-3.071,0-5.07,2.194-5.655,5.558Z"
          transform="translate(-75.527 -91.683)"
        />
        <path
          d="M821.89,448.149h7.9v7.8h-7.9Z"
          transform="translate(-96.088 -103.746)"
        />
      </g>
    </svg>
  )
}

export default MissionSP
